// component-loader.js
// Load page components.
import $ from 'jquery';
import { isFunction, each } from 'lodash'
import radio from 'radio';

export default {
  load() {
    const $components = $('.component');
    const coreSyncComponents = $('#site-components').data('core-sync').length > 0 ? $('#site-components').data('core-sync').split(',') : [];
    const coreASyncComponents = $('#site-components').data('core-async').length > 0 ? $('#site-components').data('core-async').split(',') : [];

    // Shared libraries are loaded in their own bundles.
    require('moment-mini');
    require('handlebars');

    function loadComponent(component, loadFn) {
      loadFn((file) => {
        if (isFunction(file)) {
          file();
        } else {
          file.default();
        }
        radio(`global:component-ready:${component}`).broadcast();
      });
    }

    // Sync Components
    // These components are loaded in a combined bundle and are loaded 100% of
    // the time (on every page load).
    // These components will generally load faster, but they will also
    // add to the javascript filesize and increase page load time.
    each(coreSyncComponents, (component) => {
      try {
        loadComponent(component, require(`bundle-loader!shared/components/${component}/client`));
      } catch (e) {
        // No component.
      }
    });

    // Async Components
    // These components are only loaded if the relevant component markup
    // is somewhere on the current page. These components will load slower
    // but will not hinder the overall page load time. Async load large
    // components or components that are not used on every page.
    each(coreASyncComponents, (component) => {
      if ($components.hasClass(component)) {
        loadComponent(component, require(`bundle-loader?lazy!shared/components/${component}/client`));
      }
    });
  },
};



// WEBPACK FOOTER //
// ./~/unicorn/shared/utils/component-loader.js
